<template>
  <div v-if="open">
    <div class="modal-backdrop fade show"></div>
    <div
      v-if="open"
      class="modal fade show"
      id="modal-user"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modal-user-label"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modal-user-label">
              {{ modalName }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              @click="closeModal()"
            ></button>
          </div>
          <div class="modal-body">
            <UserDetail
              v-if="!isNew && !isEdit && !isChangePwd && selected"
              :selected="selected"
              :isMe="isMe"
              @refresh="refresh"
            />
            <UserEdit
              v-if="(isNew || isEdit) && !isChangePwd"
              :time="time"
              :selected="selected"
              :isNew="isNew"
              @refresh="refresh"
            />
            <ChangePassword
              v-if="!isNew && !isEdit && isChangePwd && selected"
              :selected="selected"
              :selectedName="selectedName"
              @refresh="refresh"
            />
          </div>
          <div class="modal-footer">
            <!-- Commands -->
            <div class="me-auto"></div>
            <button
              class="btn btn-outline-secondary"
              data-dismiss="modal"
              @click="closeModal()"
            >
              <font-awesome-icon :icon="['fas', 'times']" aria-label="Chiudi" />
              Chiudi
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Components */
import ChangePassword from '@/components/users/ChangePassword.vue'
import UserDetail from '@/components/users/UserDetail.vue'
import UserEdit from '@/components/users/UserEdit.vue'

export default {
  name: 'UserModal',
  components: {
    ChangePassword,
    UserDetail,
    UserEdit
  },
  data() {
    return {
      open: false
    }
  },
  props: {
    time: Date,
    selected: Number,
    selectedName: String,
    isNew: Boolean,
    isEdit: Boolean,
    isMe: Boolean,
    isChangePwd: Boolean
  },
  watch: {
    time: function() {
      this.openModal()
    }
  },
  created() {
    this.openModal()
  },
  computed: {
    modalName: function() {
      return this.isNew
        ? 'Nuovo utente'
        : this.isEdit
        ? 'Modifica utente'
        : this.isChangePwd
        ? 'Cambio password ' + this.selectedName
        : this.selectedName
    }
  },
  methods: {
    openModal() {
      if (this.time) {
        this.open = true
      }
    },
    closeModal() {
      this.open = false
    },
    refresh(alert) {
      this.closeModal()
      console.log('modal - alert', alert)
      this.$emit('refresh', alert)
    }
  }
}
</script>

<style>
.modal {
  z-index: 1070;
}
.modal-body {
  max-height: 100%;
  overflow: scroll;
}
.show {
  display: block;
}
</style>
